import React, { useContext, useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import { IconWrapper } from '../../../../common/IconWrapper';
import { faCheckCircle, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import CreateOrderLink from '../../../../common/CreateOrderLink';
import AuthContext from '../../../../authentication/AuthContext';
import UserContext from '../../../../user/UserContext';
import axios from 'axios';
import OrderContext from '../../OrderContext';
import { useAlert } from 'react-alert';

export default function PostSubmissionMinimumOrderQuantity() {
    const cas = useContext(AuthContext);
    const { userDetails } = useContext(UserContext);
    const { orderHeader } = useContext(OrderContext);
    const alert = useAlert();

    const [singleMoq, setSingleMoq] = useState();
    const [division, setDivision] = useState('');
    const [inError, setInError] = useState(false);

    useEffect(() => {
        if (userDetails.currentFranchise) {
            axios
                .get(window.CONFIG['ws.activoc-web-order-api.moq.progress'], {
                    headers: {
                        Authorization: cas,
                        'Content-Type': 'application/json'
                    },
                    params: {
                        franchiseCode: userDetails.currentFranchise.code
                    }
                })
                .then(response => {
                    const isAmbient = orderHeader.supplierName === 'Nisa Ambient';
                    let moq = isAmbient ? response.data.ambient : response.data.chillfreeze;
                    setSingleMoq(moq);
                    setDivision(isAmbient ? 'Ambient' : 'Chill and Freeze');
                    setInError(moq.submittedCases < moq.minimumOrderQtyNoSurcharge || moq.errorMessages.length > 0);
                })
                .catch(() => {
                    alert.error('Unable to retrieve MOQ progress');
                });
        }
        // eslint-disable-next-line
    }, [cas, userDetails]);

    return singleMoq ? (
        <Row className={'order-status-information flex moq-banner' + (inError ? ' error' : ' success')}>
            <div className={'icon'}>
                <IconWrapper icon={inError ? faExclamationCircle : faCheckCircle} />
            </div>
            <div className={'text'}>
                {!inError && <span className={'top-row'}>You have reached your Minimum Order Quantity.</span>}
                {inError && (
                    <>
                        <div className={'flex button-header'}>
                            <div>
                                <span className={'top-row'}>
                                    You have ordered {singleMoq.submittedCases}/{singleMoq.minimumOrderQtyNoSurcharge}
                                    {' ' + division + ' '}
                                    cases*.
                                </span>
                                <br />
                                <span className={'top-row moq'}>
                                    You need to create an order to ensure you meet your minimum order
                                    quantity.
                                </span>
                            </div>
                            <CreateOrderLink />
                        </div>
                        <p>*Case numbers may have been modified by Nisa at submission.</p>
                        <ul className={'fa-ul'}>
                            {singleMoq.errorMessages.map((message, index) => (
                                <li key={index}>
                                    <span className="fa-li error">
                                        <IconWrapper icon={faExclamationCircle} />
                                    </span>
                                    {message}
                                </li>
                            ))}
                            {singleMoq.infoMessages.map((message, index) => (
                                <li key={index}>
                                    <span className="fa-li success">
                                        <IconWrapper icon={faCheckCircle} />
                                    </span>
                                    {message}
                                </li>
                            ))}
                        </ul>
                    </>
                )}
            </div>
        </Row>
    ) : (
        <></>
    );
}
